/* Mats · Tabla de medidas (snippets/mats-size-chart.liquid)
   - Dibujo de la prenda a escala (SVG) que cambia con la talla, con cotas A/B/C
   - Tabla con la talla activa resaltada, cm / pulgadas, resalte por columna
   - Comparador «tu camiseta favorita»
   Eventos en window:  escucha mats:size:change {size} · lanza mats:size:pick {size} */
(() => {
  if (window.__matsSizeChart) return;
  window.__matsSizeChart = true;

  const SVGNS = 'http://www.w3.org/2000/svg';
  const VB_W = 420;
  const VB_H = 340;

  const norm = (s) => String(s || '').toUpperCase().replace(/\s+/g, '').replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
  const fmt = (n) => {
    if (!isFinite(n)) return '—';
    const r = Math.round(n * 10) / 10;
    return (Number.isInteger(r) ? String(r) : r.toFixed(1)).replace('.', matsT('sc_decimal_sep', ','));
  };

  /* Parámetros de silueta (en cm) */
  const SHAPES = {
    regular:  { drop: 0, slope: 3, neck: 0.17, dip: 7,  arm: 0.42, angle: 24, sleeve: 0.34, cuff: 0,   rib: 0, hood: false },
    relaxed:  { drop: 5, slope: 3.5, neck: 0.16, dip: 7, arm: 0.40, angle: 30, sleeve: 0.40, cuff: 0,  rib: 0, hood: false },
    boxy:     { drop: 4, slope: 3, neck: 0.17, dip: 7,  arm: 0.38, angle: 28, sleeve: 0.40, cuff: 0,   rib: 0, hood: false },
    sudadera: { drop: 6, slope: 4, neck: 0.16, dip: 6,  arm: 0.40, angle: 66, sleeve: 0.30, cuff: 6.5, rib: 6.5, hood: false },
    hoodie:   { drop: 6, slope: 4, neck: 0.17, dip: 4,  arm: 0.40, angle: 66, sleeve: 0.30, cuff: 6.5, rib: 6.5, hood: true },
  };

  function geometry(shapeName, A, B, C) {
    const sh = SHAPES[shapeName] || SHAPES.regular;
    const w = A / 2;
    const nw = A * sh.neck;
    const th = (sh.angle * Math.PI) / 180;
    const dir = [Math.cos(th), Math.sin(th)];
    const nrm = [-Math.sin(th), Math.cos(th)];
    const S = [w + sh.drop, sh.slope];
    const sw = A * sh.sleeve;
    const E1 = [S[0] + C * dir[0], S[1] + C * dir[1]];
    const E2 = [E1[0] + sw * nrm[0], E1[1] + sw * nrm[1]];
    const P = [w, sh.slope + A * sh.arm];
    const H = [w, B];
    return { sh, w, nw, th, dir, nrm, S, sw, E1, E2, P, H, A, B, C };
  }

  function outline(g) {
    const m = (p) => [-p[0], p[1]];
    const pt = (p) => `${p[0].toFixed(2)} ${p[1].toFixed(2)}`;
    const nl = [-g.nw, 0];
    const nr = [g.nw, 0];
    // Escote delantero: curva con caída «dip»
    let d = `M ${pt(nl)} Q 0 ${(g.sh.dip * 2).toFixed(2)} ${pt(nr)}`;
    d += ` L ${pt(g.S)} L ${pt(g.E1)} L ${pt(g.E2)} L ${pt(g.P)} L ${pt(g.H)}`;
    d += ` L ${pt(m(g.H))} L ${pt(m(g.P))} L ${pt(m(g.E2))} L ${pt(m(g.E1))} L ${pt(m(g.S))} Z`;
    return d;
  }

  function details(g) {
    const parts = [];
    const pt = (p) => `${p[0].toFixed(2)} ${p[1].toFixed(2)}`;
    const m = (p) => [-p[0], p[1]];
    // Cuello (canalé)
    parts.push(`M ${pt([-g.nw, 0])} Q 0 ${(g.sh.dip * 2 + 4).toFixed(2)} ${pt([g.nw, 0])}`);
    // Costura de hombro caído
    if (g.sh.drop > 0) {
      parts.push(`M ${pt([g.w, g.sh.slope])} L ${pt(g.P)}`);
      parts.push(`M ${pt(m([g.w, g.sh.slope]))} L ${pt(m(g.P))}`);
    }
    // Puños y bajo de canalé
    if (g.sh.cuff) {
      const k = (g.C - g.sh.cuff) / g.C;
      const c1 = [g.S[0] + (g.E1[0] - g.S[0]) * k, g.S[1] + (g.E1[1] - g.S[1]) * k];
      const c2 = [c1[0] + g.sw * g.nrm[0], c1[1] + g.sw * g.nrm[1]];
      parts.push(`M ${pt(c1)} L ${pt(c2)}`, `M ${pt(m(c1))} L ${pt(m(c2))}`);
    }
    if (g.sh.rib) parts.push(`M ${pt([-g.w, g.B - g.sh.rib])} L ${pt([g.w, g.B - g.sh.rib])}`);
    return parts.join(' ');
  }

  function hood(g) {
    if (!g.sh.hood) return '';
    const h = g.A * 0.62;
    const x = g.nw + 3;
    return `M ${-x} 1 C ${-x - 4} ${-h * 0.75} ${-x * 0.4} ${-h} 0 ${-h} C ${x * 0.4} ${-h} ${x + 4} ${-h * 0.75} ${x} 1`;
  }

  class MatsSizeChart {
    constructor(root) {
      this.root = root;
      this.mode = root.dataset.mode || 'full';
      try {
        this.data = JSON.parse(root.querySelector('[data-mb-sc-data]').textContent);
      } catch (e) {
        return;
      }
      this.rows = (this.data.rows || []).map((r) => ({ size: r.size, key: norm(r.size), v: r.values.map((x) => parseFloat(x)) }));
      if (!this.rows.length) return;
      this.unit = 'cm';
      this.svg = root.querySelector('[data-mb-sc-svg]');
      this.index = Math.min(1, this.rows.length - 1);
      if (this.svg) this.prepareScale();
      this.bind();
      this.set(this.index, false);
      root.__matsSizeChart = this;
    }

    /* Escala única para todas las tallas: la más grande cabe en el lienzo */
    prepareScale() {
      const shape = this.data.shape;
      let maxX = 0;
      let minY = 0;
      let maxY = 0;
      this.rows.forEach((r) => {
        const [A, B, C] = r.v;
        if (!isFinite(A) || !isFinite(B)) return;
        const g = geometry(shape, A, B, isFinite(C) ? C : 20);
        maxX = Math.max(maxX, g.S[0], g.E1[0], g.E2[0], g.w);
        maxY = Math.max(maxY, g.B, g.E1[1], g.E2[1]);
        if (g.sh.hood) minY = Math.min(minY, -g.A * 0.62);
      });
      const padX = 34;
      const padTop = 22;
      const padBottom = 30;
      this.k = Math.min((VB_W - padX * 2) / (maxX * 2 + 10), (VB_H - padTop - padBottom) / (maxY - minY));
      this.ox = VB_W / 2;
      this.oy = padTop - minY * this.k + ((VB_H - padTop - padBottom) - (maxY - minY) * this.k) / 2;
    }

    bind() {
      const r = this.root;
      r.querySelectorAll('[data-mb-sc-tab]').forEach((b) => b.addEventListener('click', () => this.setBySize(b.dataset.mbScTab, false)));
      r.querySelectorAll('[data-mb-sc-row]').forEach((tr) => {
        const act = () => this.setBySize(tr.dataset.mbScRow, this.mode === 'compact');
        tr.addEventListener('click', act);
        tr.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); act(); } });
      });
      r.querySelectorAll('[data-mb-sc-unit]').forEach((b) => b.addEventListener('click', () => this.setUnit(b.dataset.mbScUnit)));

      // Resalte por columna
      r.querySelectorAll('[data-mb-sc-col]').forEach((el) => {
        el.addEventListener('mouseenter', () => this.hiCol(Number(el.dataset.mbScCol)));
        el.addEventListener('mouseleave', () => this.hiCol(null));
      });

      const finder = r.querySelector('[data-mb-sc-finder]');
      if (finder) finder.addEventListener('submit', (e) => { e.preventDefault(); this.find(); });
      const pick = r.querySelector('[data-mb-sc-pick]');
      if (pick) pick.addEventListener('click', () => this.pick(pick.dataset.size));

      window.addEventListener('mats:size:change', (e) => {
        if (!e.detail || !e.detail.size) return;
        const i = this.rows.findIndex((x) => x.key === norm(e.detail.size));
        if (i > -1) this.set(i, false);
      });
    }

    setBySize(size, emit) {
      const i = this.rows.findIndex((x) => x.key === norm(size));
      if (i < 0) return;
      this.set(i, true);
      if (emit) this.pick(this.rows[i].size);
    }

    pick(size) {
      if (!size) return;
      window.dispatchEvent(new CustomEvent('mats:size:pick', { detail: { size } }));
    }

    set(i, user) {
      this.index = i;
      const row = this.rows[i];
      this.root.querySelectorAll('[data-mb-sc-tab]').forEach((b) => b.setAttribute('aria-checked', String(norm(b.dataset.mbScTab) === row.key)));
      this.root.querySelectorAll('[data-mb-sc-row]').forEach((tr) => tr.classList.toggle('is-active', norm(tr.dataset.mbScRow) === row.key));
      this.root.querySelectorAll('[data-mb-sc-val]').forEach((el) => {
        const v = row.v[Number(el.dataset.mbScVal)];
        el.textContent = this.label(v);
      });
      if (this.svg) this.draw();
      this.root.dispatchEvent(new CustomEvent('mb-sc:preview', { bubbles: true, detail: { size: row.size, user } }));
    }

    label(cm) {
      if (!isFinite(cm)) return '—';
      return this.unit === 'in' ? `${fmt(cm / 2.54)} ″` : `${fmt(cm)} cm`;
    }

    setUnit(unit) {
      this.unit = unit === 'in' ? 'in' : 'cm';
      this.root.dataset.unit = this.unit;
      this.root.querySelectorAll('[data-mb-sc-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mbScUnit === this.unit)));
      this.root.querySelectorAll('td[data-cm]').forEach((td) => {
        const v = parseFloat(td.dataset.cm);
        td.textContent = this.unit === 'in' ? fmt(v / 2.54) : fmt(v);
      });
      const unitLabel = this.root.querySelector(`[data-mb-sc-unit="${this.unit}"]`);
      this.root.querySelectorAll('[data-mb-sc-unit-label]').forEach((el) => { el.textContent = unitLabel ? unitLabel.textContent : this.unit; });
      this.set(this.index, false);
    }

    hiCol(i) {
      this.root.classList.toggle('is-col-hover', i !== null);
      this.root.querySelectorAll('.mb-sc__table [data-mb-sc-col]').forEach((c) => c.classList.toggle('is-col-hi', i !== null && Number(c.dataset.mbScCol) === i));
      if (this.svg) this.svg.querySelectorAll('.g-dim').forEach((g) => g.classList.toggle('is-hi', i !== null && Number(g.dataset.col) === i));
    }

    /* ---------- Dibujo ---------- */
    draw() {
      const svg = this.svg;
      const row = this.rows[this.index];
      const [A, B, C] = row.v;
      if (!isFinite(A) || !isFinite(B)) { svg.innerHTML = ''; return; }
      const shape = this.data.shape;
      const k = this.k;
      const T = (p) => [this.ox + p[0] * k, this.oy + p[1] * k];
      const g = geometry(shape, A, B, isFinite(C) ? C : 20);
      const tf = `translate(${this.ox.toFixed(2)} ${this.oy.toFixed(2)}) scale(${k.toFixed(4)})`;

      let html = '';
      html += `<text class="g-size" x="${VB_W - 14}" y="${VB_H - 12}" text-anchor="end">${row.size}</text>`;

      // Talla anterior como referencia
      const prev = this.rows[this.index - 1];
      if (prev && isFinite(prev.v[0]) && isFinite(prev.v[1])) {
        const gp = geometry(shape, prev.v[0], prev.v[1], isFinite(prev.v[2]) ? prev.v[2] : 20);
        html += `<g transform="${tf}"><path class="g-ghost" vector-effect="non-scaling-stroke" d="${outline(gp)}"/></g>`;
      }

      html += `<g transform="${tf}">`;
      if (g.sh.hood) html += `<path class="g-body" vector-effect="non-scaling-stroke" d="${hood(g)}"/>`;
      html += `<path class="g-body" vector-effect="non-scaling-stroke" d="${outline(g)}"/>`;
      html += `<path class="g-detail" vector-effect="non-scaling-stroke" d="${details(g)}"/>`;
      html += '</g>';

      // Cotas (en coordenadas del lienzo para que el grosor y el texto no escalen)
      const arrow = (p, ang) => {
        const s = 5;
        const a1 = ang + Math.PI * 0.85;
        const a2 = ang - Math.PI * 0.85;
        return `<path class="g-dim-arrow" d="M ${p[0]} ${p[1]} L ${p[0] + s * Math.cos(a1)} ${p[1] + s * Math.sin(a1)} L ${p[0] + s * Math.cos(a2)} ${p[1] + s * Math.sin(a2)} Z"/>`;
      };
      const dim = (col, p1, p2, badgeAt) => {
        const ang = Math.atan2(p2[1] - p1[1], p2[0] - p1[0]);
        return `<g class="g-dim" data-col="${col}"><line x1="${p1[0]}" y1="${p1[1]}" x2="${p2[0]}" y2="${p2[1]}"/>${arrow(p2, ang)}${arrow(p1, ang + Math.PI)}<circle cx="${badgeAt[0]}" cy="${badgeAt[1]}" r="10"/><text x="${badgeAt[0]}" y="${badgeAt[1]}">${'ABCDEF'[col]}</text></g>`;
      };

      // A · pecho (a la altura de la axila)
      const ay = g.P[1] + 2.5;
      const a1 = T([-g.w + 0.6, ay]);
      const a2 = T([g.w - 0.6, ay]);
      html += dim(0, a1, a2, [(a1[0] + a2[0]) / 2, a1[1]]);

      // B · largo (del hombro junto al cuello al bajo)
      const bx = -g.nw - 1.5;
      const b1 = T([bx, 0.6]);
      const b2 = T([bx, g.B - 0.6]);
      html += dim(1, b1, b2, [b1[0], b1[1] + (b2[1] - b1[1]) * 0.7]);

      // C · manga (por fuera del borde superior)
      if (isFinite(C)) {
        const off = 4.5;
        const o = [Math.sin(g.th) * off, -Math.cos(g.th) * off];
        const c1 = T([g.S[0] + o[0], g.S[1] + o[1]]);
        const c2 = T([g.E1[0] + o[0], g.E1[1] + o[1]]);
        html += dim(2, c1, c2, [(c1[0] + c2[0]) / 2 + 2, (c1[1] + c2[1]) / 2 - 2]);
      }

      svg.innerHTML = html;
    }

    /* ---------- Comparador ---------- */
    find() {
      const r = this.root;
      const box = r.querySelector('[data-mb-sc-result]');
      const text = r.querySelector('[data-mb-sc-result-text]');
      const pick = r.querySelector('[data-mb-sc-pick]');
      const toCm = (v) => (this.unit === 'in' ? v * 2.54 : v);
      const a = toCm(parseFloat(String(r.querySelector('[data-mb-sc-input="0"]')?.value || '').replace(',', '.')));
      const b = toCm(parseFloat(String(r.querySelector('[data-mb-sc-input="1"]')?.value || '').replace(',', '.')));
      box.hidden = false;
      box.classList.remove('is-far');
      if (!isFinite(a)) {
        text.textContent = r.dataset.labelEmpty;
        box.classList.add('is-far');
        return;
      }
      let best = -1;
      let bestD = Infinity;
      this.rows.forEach((row, i) => {
        let d = Math.abs(row.v[0] - a);
        if (isFinite(b) && isFinite(row.v[1])) d += Math.abs(row.v[1] - b) * 0.5;
        if (d < bestD) { bestD = d; best = i; }
      });
      if (best < 0 || Math.abs(this.rows[best].v[0] - a) > 3.5) {
        text.textContent = r.dataset.labelFar;
        box.classList.add('is-far');
        return;
      }
      const size = this.rows[best].size;
      this.set(best, true);
      text.textContent = r.dataset.labelResult.replace('[size]', size);
      pick.textContent = r.dataset.labelPick.replace('[size]', size);
      pick.dataset.size = size;
    }
  }

  const init = (scope = document) => scope.querySelectorAll('[data-mb-sc]').forEach((el) => { if (!el.__matsSizeChart) new MatsSizeChart(el); });
  window.MatsSizeChart = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
